import { FarmInToken } from "./farm-state/types";

export const fullFarmDateOptions = {
  day: "numeric",
  month: "short",
  year: "numeric",
} as const;

export const shortFarmDateOptions = {
  day: "numeric",
  month: "short",
} as const;

export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

export const ETH: FarmInToken = {
  symbol: "ETH",
  shouldBeSwapped: true,
  needApprove: false,
  decimals: 18,
};
